import _ from 'lodash';
export function sleep(timeout) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, timeout);
    });
}
export function withLoading(self, p, useLoading = true) {
    if (!useLoading) {
        return p;
    }
    self.loading = true;
    return p.finally(() => {
        self.loading = false;
    });
}
export function withFieldLoading(self, p, field) {
    self[field] = true;
    return p.finally(() => {
        self[field] = false;
    });
}
export class TaskSource {
    _promise;
    _resolve;
    _reject;
    _fired = false;
    constructor() {
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get Promise() {
        return this._promise;
    }
    Resolve(t) {
        if (this._fired) {
            console.error('Can not Resolve fired source');
            return;
        }
        this._fired = true;
        this._resolve(t);
    }
    // todo
    TryResolve(t) {
        if (this._fired) {
            return false;
        }
        this.Resolve(t);
    }
    Reject(e) {
        if (this._fired) {
            console.error('Can not Resolve fired source');
            return;
        }
        this._fired = true;
        this._reject(e);
    }
    get Fired() {
        return this._fired;
    }
}
const TimeoutExceptionSymbol = Symbol.for('TimeoutException');
export class TimeoutException extends Error {
    err;
    cls = TimeoutExceptionSymbol;
    constructor(err) {
        super(`TimeoutException${err}`);
        this.err = err;
    }
}
export const IsTimeoutException = (e) => {
    return (e instanceof TimeoutException) || (_.get(e, 'cls') === TimeoutExceptionSymbol);
};
export function withTimeout(p, timeout = 10, tag = '') {
    return new Promise((resolve, reject) => {
        let resolved = false;
        const handler = setTimeout(() => {
            if (resolved) {
                return;
            }
            resolved = true;
            reject(new TimeoutException(tag));
        });
        p.then(res => {
            if (resolved) {
                return;
            }
            resolved = true;
            clearTimeout(handler);
            resolve(res);
        }, err => {
            if (resolved) {
                //! !!todo
                return;
            }
            resolved = true;
            clearTimeout(handler);
            reject(err);
        });
    });
}
export function toBooleanPromise(p) {
    return p.then(() => true, () => false);
}
export var E_ConfirmResult;
(function (E_ConfirmResult) {
    E_ConfirmResult["CONFIRM"] = "CONFIRM";
    E_ConfirmResult["CANCEL"] = "CANCEL";
    E_ConfirmResult["CLOSE"] = "CLOSE";
    /**
     * 忽略或者跳过
     */
    E_ConfirmResult["IGNORE"] = "IGNORE";
})(E_ConfirmResult || (E_ConfirmResult = {}));
